export class CustomError extends Error {
  constructor(message: string, functionName?: string) {
    super(message)
    this.message = message

    console.log(`Error${functionName ? ` in ${functionName}` : ''}: ${message}`)
  }
}
